import Model from "./Model";

export default class Notification extends Model {

    static send = async (input) => {
        const res = await this.runMutation(SendNotificationMutation, { input });
        return res.data.sendNotification;
    }

    static recent = async (limit = 25) => {
        const res = await this.runQueryNetworkOnly(RecentNotificationsQuery, { limit });
        return res.data.recentNotifications || [];
    }

    static archive = async (notification_uuid) => {
        const res = await this.runMutation(ArchiveNotificationMutation, { notification_uuid });
        return res.data.archiveNotification;
    }

    static recipients = async (notification_uuid) => {
        const res = await this.runQueryNetworkOnly(NotificationRecipientsQuery, { notification_uuid });
        return res.data.notificationRecipients || [];
    }

    // The current user's own inbox (same query the mobile app consumes)
    static mine = async (user_id, company_id) => {
        const res = await this.runQueryNetworkOnly(MyNotificationsQuery, { user_id, company_id });
        return res.data.myNotifications || [];
    }

    static markRead = async (notification_uuid, user_id) => {
        const res = await this.runMutation(MarkNotificationReadMutation, { notification_uuid, user_id });
        return res.data.markNotificationRead;
    }
}

const SendNotificationMutation = `
mutation sendNotification($input: SendNotificationInput){
    sendNotification(input: $input){
        id
        uuid
        title
        severity
        audience_type
        company_id
        created_at
    }
}`;

const RecentNotificationsQuery = `
query recentNotifications($limit: Int){
    recentNotifications(limit: $limit){
        uuid
        title
        body
        severity
        audience_type
        company_id
        company_name
        company_names
        company_ids
        created_by_name
        read_count
        target_user_count
        archived
        expires_at
        created_at
        links
    }
}`;

const NotificationRecipientsQuery = `
query notificationRecipients($notification_uuid: ID!){
    notificationRecipients(notification_uuid: $notification_uuid){
        user_id
        full_name
        email
        company_name
        read_at
        targeted
    }
}`;

const ArchiveNotificationMutation = `
mutation archiveNotification($notification_uuid: ID!){
    archiveNotification(notification_uuid: $notification_uuid)
}`;

const MyNotificationsQuery = `
query myNotifications($user_id: Int!, $company_id: Int){
    myNotifications(user_id: $user_id, company_id: $company_id){
        uuid
        title
        body
        severity
        audience_type
        created_at
        expires_at
        is_read
        links
    }
}`;

const MarkNotificationReadMutation = `
mutation markNotificationRead($notification_uuid: ID!, $user_id: Int!){
    markNotificationRead(notification_uuid: $notification_uuid, user_id: $user_id)
}`;
